<template>
      <tr>
            <td :colspan="columns.length">
                  <table class="table-fixed w-full">
                        <tr class="bg-trueGray sticky-groupBy">
                              <td class="px-2 h-12 cursor-pointer" :colspan="columns.length" @click="collapsed = !collapsed">
                                    <feather :type="collapsed ? 'chevron-down' : 'chevron-right'" :stroke="theme.colors.pureNavy" class="pr-4 absolute -mt-2.5"></feather>
                                    <div class="absolute ml-10 inline-block leading-6 -mt-2.5">{{ group_by }}: <span class="font-bold">{{ name }}</span> <span class="badge bg-pureNavy ml-2 px-1.5 py-0.5 rounded-full text-white text-xs">{{ badge(childRows.length)}} </span></div>
                              </td>
                        </tr>
                        <table-row
                              :isArray="Array.isArray(rows)"
                              :collapsed="collapsed"
                              :columns="columns"
                              v-for="(item, i) in slicedList"
                              :key="'bbb-'+ i"
                              :item="item"
                              :class="slicedList.length - 1 == i ? 'last' : null"
                              :showMoreVisible="isVisible"
                              :dinamicColumn="dinamicColumn"
                              :odd="i % 2 === 1"
                        />
                        <tr v-show="isVisible" class="show-more">
                              <td class="flex pb-4 pt-4">
                                    <div class="bg-gray-100 border-navy cursor-pointer hover:text-navy px-2 py-1 rounded-full text-gray-600 flex items-center" @click="showMore()"> {{ $t('show_more') }} <span class="bg-gray-400 ml-1 px-1 rounded-full text-white text-xs">{{ childRows.length - counter }}</span></div>
                              </td>
                        </tr>
                  </table>
            </td>
      </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import TableRow from './TableRow.vue'
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../tailwind.config.js'
export default {
      name: 'collapsibleRow',
      components: {
            TableRow
      },
      props: {
            columns: {
                  type: Array,
                  required: true,
            },
            rows: {
                  type: Object,
                  required: true,
            },
            childRows: {
                  type: Array,
                  required: true,
            },
            name: {
                  type: String
            },
            dinamicColumn: {
                  type: Object,
                  required: true,
            },
      },
      data(){
            const {theme} = resolveConfig(tailwindConfig)
            return {
                  collapsed: false,
                  showMoreLimit: 25,
                  counter: 10,
                  theme: theme,
            }
      },
      computed: {
            ...mapGetters([
                  'newReport',
            ]),
            group_by(){
                  return JSON.parse(this.newReport.group_by_stringify)[0]
            },
            slicedList(){
                  return this.childRows.slice(0, this.counter)
            },
            isVisible(){
                  if(this.collapsed && this.counter < this.childRows.length) return true
                  else return false
            },
      },
      methods: {
            showMore(){
                  this.counter += this.showMoreLimit
            },
            badge(counter){
                  if(counter > 1) {
                        return counter + ' items'
                  } else {
                        return counter + ' item'
                  }
            }
      }
}
</script>

<style lang="sass">
.sticky-groupBy
      position: sticky
      top: 2.2rem
table
      .contents.odd
            tr
                  @apply bg-gray-100
      .contents.last
            td.showMoreVisible
                  @apply pb-14
      .show-more
            box-shadow: rgb(255, 255, 255) 0 0 50px 50px
            position: relative
</style>